
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitch02Off as ObiSwitch02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-02-off.js';
 
 
 

 
 export const ObiSwitch02Off = createComponent({
   react: React,
   tagName: 'obi-switch-02-off',
   elementClass: ObiSwitch02OffElement,
   events: {
     
   }
  });
 
 